import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Its arguments are of the form:
`}<inlineCode parentName="p">{`({cachedData, complete, data, params, pause, stop})`}</inlineCode>{`. Its output will replace `}<inlineCode parentName="p">{`data`}</inlineCode>{` in the state.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`data`}</strong><br />{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Represents the current value of data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`tick`}</strong><br />{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Represents the new tick.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`params`}</strong><br />{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Represents the current parameters.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`cachedData`}</strong><br />{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object so that for each past value of `}<inlineCode parentName="td">{`tick`}</inlineCode>{`, `}<inlineCode parentName="td">{`cachedData[tick]`}</inlineCode>{` represents the value of `}<inlineCode parentName="td">{`data`}</inlineCode>{` at that moment of the simulation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`complete`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A function that signals the simulation is complete (it will also stop).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`pause`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A function that will stop the simulation from automatically updating and animating.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`stop`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A function that will stop the simulation from automatically updating and animating, and will reset it.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      